.row {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 20px;
  border: 0;
  border-top: 1.5px solid var(--ink);
  background: none;
  color: var(--ink);
  font: inherit;
  text-align: left;
  cursor: pointer;
}

.tile {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: var(--radius-control);
}

.new {
  background: var(--sunk);
  color: var(--ink-2);
}

.draft {
  background: var(--private);
  color: var(--private-ink);
}

.icon {
  width: 20px;
  height: 20px;
  background-color: currentColor;
  -webkit-mask: url('./clipboard.svg') no-repeat center / contain;
  mask: url('./clipboard.svg') no-repeat center / contain;
}

.lines {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.name {
  font-size: 16px;
  font-weight: 600;
}

.details {
  font-size: 14px;
  color: var(--ink-2);
}

.action {
  font-size: 15px;
  font-weight: 700;
}

.error {
  padding: 0 20px 14px;
  font-size: 14px;
  font-weight: 600;
  color: var(--error);
}
